<template>
  <div class="template-default">
    <nav class="navbar navbar-expand-lg">
      <div class="container">
        <router-link :to="{ name: 'home' }" class="navbar-brand mr-5">
          <img class="logo" src="@/assets/logo.png" />
        </router-link>

        <div class="flex-fill d-lg-none"></div>

        <button
          class="navbar-toggler"
          type="button"
          @click="$bvModal.show('mobile-menu')"
        >
          <i class="icon-menu"></i>
        </button>

        <div class="collapse navbar-collapse" id="navbarNav">
          <main-menu @logout="logoutDialog = true" />

          <account-menu @logout="logoutDialog = true" />
        </div>
      </div>
    </nav>

    <b-modal id="mobile-menu" hide-footer>
      <template v-slot:modal-title>
        <router-link
          :to="{ name: 'home' }"
          @click.native="$bvModal.hide('mobile-menu')"
        >
          <img src="@/assets/logo.png" class="img-fluid mobile-menu-logo" />
        </router-link>
      </template>

      <main-menu
        @close="$bvModal.hide('mobile-menu')"
        @logout="logoutDialog = true"
      />
    </b-modal>

    <action-dispatcher action="user/get" class="flex-fill" @error="logout">
      <slot />
    </action-dispatcher>

    <app-footer />

    <confirmation
      v-model="logoutDialog"
      @confirm="logout"
      text="Tem certeza que deseja sair?"
      confirm-button-text="Sair"
    />
  </div>
</template>

<script>
import MainMenu from "@/components/template/MainMenu";
import AccountMenu from "@/components/template/AccountMenu";

export default {
  components: {
    MainMenu,
    AccountMenu
  },
  data() {
    return {
      logoutDialog: false
    };
  },
  methods: {
    logout() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push({ name: "login" });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.template-default {
  display: flex;
  flex-direction: column;
  min-height: 100vh;

  nav {
    background: #fbeee4;
    border-bottom: 0.5px solid #a9a395;

    .logo {
      max-height: 50px;
      margin: 10px 0;
    }
  }
}
</style>
